import {ApiClient} from './apiClient/apiClient';

const apiClient = new ApiClient();

export const loginRequest = (credentials) => {
    return apiClient.post('login', credentials);
};

export const registerRequest = (credentials) => {
    return apiClient.post('register', credentials);
}
